import React, {useState, useEffect} from 'react';
import './index.less';
import queryString from 'query-string';
import dayjs from 'dayjs';
import {Modal, Toast} from 'antd-mobile-v2';
import {Skeleton} from 'antd-mobile';
import BackHeader from '@comp/BackHeader/index';
import Rate from '../components/Rate/index';
import Title from '../components/Title/index';
import GstCheckbox from '@/components/GstCheckbox';
import GstProgessBar from '@/components/GstProgessBar';

import {fetchCommentTag, editComment, saveComment, queryDoctorDetail} from '@/store/api/doctor';
import {queryDeal, queryDealPropery, querySimpleDealDetail} from '@/store/api/deal';
import {storage, getEnv, locationTo, removeEmoji, hasEmoji, getOssUrl} from '@utils/tools';
import {host} from '@utils/hostConf';
export const COMMENT_KEY = 'COMMENT_SOURCE';

export const icons = {
  1: {
    icon: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/icon_great.png',
    iconGray: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/icon_great_gray.png',
  },
  2: {
    icon: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/icon_good.png',
    iconGray: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/icon_good_gray.png',
  },
  3: {
    icon: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/icon_average.png',
    iconGray: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/icon_average_gray.png',
  },
  4: {
    icon: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/icon_bad.png',
    iconGray: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/icon_bad_gray.png',
  },
};
export const QUESTION_LIST_MP = [
  {
    no: '1_1',
    needComment: true,
    required: true,
    ques: '对分院服务是否满意？',
    type: 'radio',
    options: [
      {
        label: '不满意',
        value: '4',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '不主动回复问题',
            value: 'a1',
            checked: false,
          },
          {
            label: '就诊流程不清晰',
            value: 'a2',
            checked: false,
          },
          {
            label: '就诊秩序混乱',
            value: 'a3',
            checked: false,
          },
          {
            label: '诊室标识不清晰',
            value: 'a4',
            checked: false,
          },
          {
            label: '诊室杂乱',
            value: 'a5',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '一般',
        value: '3',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '工服不整洁',
            value: 'a1',
            checked: false,
          },
          {
            label: '服务不热情',
            value: 'a2',
            checked: false,
          },
          {
            label: '叫号屏未开机',
            value: 'a3',
            checked: false,
          },
          {
            label: '分院位置不好找',
            value: 'a4',
            checked: false,
          },
          {
            label: '卫生间不清洁',
            value: 'a5',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '良好',
        value: '2',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务比较热情',
            value: 'a1',
            checked: false,
          },
          {
            label: '停车方便',
            value: 'a2',
            checked: false,
          },
          {
            label: '温度适宜',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '满意',
        value: '1',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务热情礼貌',
            value: 'a1',
            checked: false,
          },
          {
            label: '分院整洁明亮',
            value: 'a2',
            checked: false,
          },
          {
            label: '就诊流程顺畅',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
    ],
    ans: [],
  },
  {
    no: '2_1',
    needComment: true,
    required: true,
    ques: '对药事方面是否满意？',
    type: 'radio',
    options: [
      {
        label: '不满意',
        value: '4',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务态度差',
            value: 'a1',
            checked: false,
          },
          {
            label: '45分钟内未取到药',
            value: 'a2',
            checked: false,
          },
          {
            label: '每剂药质量差过大',
            value: 'a3',
            checked: false,
          },
          {
            label: '药品错发漏发',
            value: 'a4',
            checked: false,
          },
          {
            label: '取药时未告知注意事项',
            value: 'a5',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '一般',
        value: '3',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '工服不整洁',
            value: 'a1',
            checked: false,
          },
          // {
          //   label: '没佩戴口罩、帽子',
          //   value: 'a2',
          //   checked: false,
          // },
          {
            label: '服务不热情',
            value: 'a3',
            checked: false,
          },
          {
            // label: '提示后未及时发药',
            label: '分院取药不及时',
            value: 'a4',
            checked: false,
          },
          {
            label: '取药时未告知煎煮方法',
            value: 'a6',
            checked: false,
          },
          {
            label: '没有电子秤称重',
            value: 'a5',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '良好',
        value: '2',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务比较热情',
            value: 'a1',
            checked: false,
          },
          {
            label: '取药不超过35分钟',
            value: 'a2',
            checked: false,
          },
          {
            label: '用法标注清晰',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '满意',
        value: '1',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务热情礼貌',
            value: 'a1',
            checked: false,
          },
          {
            label: '取药快速便捷',
            value: 'a2',
            checked: false,
          },
          {
            label: '有电子秤克重放心',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
    ],
    ans: [],
  },
  {
    no: '2_2',
    needComment: false,
    required: true,
    ques: '取药时间大概有多久？',
    placeholder: '请输入取药时间',
    type: 'textarea',
    inputValue: '',
    ans: [],
  },
  {
    no: '3_1',
    needComment: true,
    required: true,
    ques: '对护士服务是否满意？',
    type: 'radio',
    options: [
      {
        label: '不满意',
        value: '4',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务态度差',
            value: 'a1',
            checked: false,
          },
          {
            label: '治疗操作不专业',
            value: 'a2',
            checked: false,
          },
          {
            label: '治疗室杂乱无章',
            value: 'a3',
            checked: false,
          },
          {
            label: '消毒不到位',
            value: 'a4',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '一般',
        value: '3',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '工服不整洁',
            value: 'a1',
            checked: false,
          },
          {
            label: '没佩戴口罩、帽子',
            value: 'a2',
            checked: false,
          },
          {
            label: '服务不热情',
            value: 'a3',
            checked: false,
          },
          {
            label: '无一次性医疗用品',
            value: 'a4',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '良好',
        value: '2',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务比较热情',
            value: 'a1',
            checked: false,
          },
          {
            label: '候诊区整洁',
            value: 'a2',
            checked: false,
          },
          {
            label: '治疗操作熟练',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '满意',
        value: '1',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务热情礼貌',
            value: 'a1',
            checked: false,
          },
          {
            label: '诊室整洁明亮',
            value: 'a2',
            checked: false,
          },
          {
            label: '叫号井然有序',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
    ],
    ans: [],
  },
  {
    no: '4_1',
    needComment: true,
    required: true,
    ques: '对挂号收费服务是否满意',
    type: 'radio',
    options: [
      {
        label: '不满意',
        value: '4',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '挂号取号不顺畅',
            value: 'a1',
            checked: false,
          },
          {
            label: '排队超过5分钟',
            value: 'a2',
            checked: false,
          },
          {
            label: '不耐心解答问题',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '一般',
        value: '3',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '工服不整洁',
            value: 'a1',
            checked: false,
          },
          {
            label: '没佩戴口罩、帽子',
            value: 'a2',
            checked: false,
          },
          {
            label: '服务不热情',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '良好',
        value: '2',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '服务比较热情',
            value: 'a1',
            checked: false,
          },
          {
            label: '排队不超过3分钟',
            value: 'a2',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
      {
        label: '满意',
        value: '1',
        checked: false,
        type: 'checkbox',
        list: [
          {
            label: '有耐心态度好',
            value: 'a1',
            checked: false,
          },
          {
            label: '挂号取号便捷',
            value: 'a2',
            checked: false,
          },
          {
            label: '操作娴熟高效',
            value: 'a3',
            checked: false,
          },
          {
            label: '其他',
            value: 'a99',
            checked: false,
            remark: true,
            note: '',
          },
        ],
      },
    ],
    ans: [],
  },
];
export const QUESTION_LIST_MP2 = [
  {
    no: '101_1',
    needComment: false,
    ques: '您从哪个渠道关注到了固生堂?',
    type: 'checkbox',
    options: [
      {
        label: '小红书',
        value: 'a1',
        checked: false,
      },
      {
        label: '美团',
        value: 'a2',
        checked: false,
      },
      {
        label: '医生推荐',
        value: 'a3',
        checked: false,
      },
      {
        label: '朋友介绍',
        value: 'a4',
        checked: false,
      },
      {
        label: '住在附近',
        value: 'a5',
        checked: false,
      },
      {
        label: '其他渠道',
        value: 'a99',
        checked: false,
        remark: true,
        note: '',
      }
    ]
  }
]
const CommentIndex = props => {
  const [isMP, setMP] = useState(storage.get(COMMENT_KEY, 'session') === 'mp');
  const {deal_id, mis_doctor_id, doctor_id, user_id, source, type, comment_id} = queryString.parse(
    props.location.search
  );
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const [deal, setDeal] = useState({});
  const [tmap, setTmap] = useState({});
  const [tagList, setTagList] = useState([]);
  const [phraseList, setPhraseList] = useState([]);
  const [quesList, setQuesList] = useState(QUESTION_LIST_MP);
  const [quesListMP, setQuesListMP] = useState(QUESTION_LIST_MP2);
  const [dealPropery, setDealPropery] = useState({});
  const [warnQues, setWarnQues] = useState([]);
  const [showHeader, setShowHeader] = useState(false);
  const [doctor, setDoctor] = useState({});
  const [percent, setPercent] = useState(0);
  const [visiblePopover, setVisiblePopover] = useState(false);
  const [popoverText, setPopoverText] = useState('');
  useEffect(() => {
    getEnv(res => {
      if (res == 'miniprogram') {
        setShowHeader(false);
      } else if (res == 'iOSApp') {
        setShowHeader(false);
      } else if (res == 'androidApp') {
        setShowHeader(false);
      } else if (res == 'h5') {
        setShowHeader(true);
      } else {
        setShowHeader(true);
      }
    });
    queryCommentTag();
    setLoading(true);
    Promise.all([onQueryDealPropery(), getDeal()]).then(res => {
      console.log(res);
      initQues(res[0], res[1]);
      getDoctorDetail(res[1].doctor_id);
      setLoading(false);
    });
  }, []);
  useEffect(
    e => {
      popoverTextFun();
    },
    [quesList, form, tmap, quesListMP]
  );
  useEffect(
    e => {
      if (percent > 0 && !visiblePopover) {
        setTimeout(() => {
          setVisiblePopover(true);
        }, 1000);
      }
    },
    [percent]
  );

  // 答题进度提示框
  const popoverTextFun = () => {
    let percent = 0;

    // quesList问题数
    let ques = quesList.filter(item => item.needComment == true);
    let answeredQuesNum = ques.filter(item => item.options?.some(item => item.checked) || (item.inputValue && item.inputValue.trim() && item.type==='textarea')).length;
    let answeredDocNum = 0;
    if (form.score > 0) {
      answeredDocNum++;
    }
    if (form.referral_score > 0) {
      answeredDocNum++;
    }

    // quesListMP 问题数
    let _quesListMP = quesListMP.filter(item => item.needComment == true);
    let answeredQuesNumMP = _quesListMP.filter(item => item.options.some(item => item.checked)).length;

    // 问题总数
    let allQuesNum = ques.length;
    if (dealPropery.is_only_hs_zhiliao == 0) {
      allQuesNum += 2
    }
    allQuesNum += _quesListMP.length;

    percent = (((answeredQuesNum + answeredDocNum + answeredQuesNumMP) / allQuesNum) * 100).toFixed(0);
    let text = percent > 0 ? `已完成：${percent}%，答案将会自动暂存` : '';
    setPercent(percent);
    setPopoverText(text);
  };

  // 保存答案在本地（暂存）
  const saveAnswer = async tmaps => {
    let _tmap = tmaps || {...tmap};
    let _form = getAnsResult(_tmap);
    storage.set('commentForm', {deal_id, form: _form, tmap: _tmap});
  };

  /**
   * 处理answer，得到数据结构
   * @param {*} tmaps
   * @returns
   */
  const getAnsResult = (tmaps) => {
    let _form = {...form};
    let _tmap = tmaps || {...tmap}
    // 医生标签
    let tags = [];
    const arr = Object.entries(_tmap).filter(item => item[1]);
    arr.forEach(item => {
      const {score_type, tag, tag_id, tag_type} = tagList[item[0]];
      tags.push({
        score_type,
        tag_type,
        tag_id,
        tag_name: tag,
      });
    });
    _form.tag = tags;

    // 问答
    let question_paper = quesList
      .filter(item => item.needComment)
      .map((item, i) => {
        let tag = [];
        let checkedOption = item.options ? item.options.find(ite => ite.checked) || {} : {};
        if (checkedOption.value) {
          let check = checkedOption.list.filter(ite => ite.checked && !ite.remark);
          let remark = checkedOption.list.filter(ite => ite.checked && ite.remark && ite.note);
          tag = [
            ...Array.from(check, x => x.value + '_' + x.label),
            ...Array.from(remark, x => x.value + '_' + x.note),
          ];
        }
        // let _item = {
        //   no: item.no,
        //   question: item.ques,
        //   type: item.type,
        //   index: i + 1,
        //   score: checkedOption.value ? checkedOption.value + '_' + checkedOption.label : '',
        //   inputValue: item.inputValue,
        //   tag: tag,
        // }
        return {
          no: item.no,
          question: item.ques,
          type: item.type,
          index: i + 1,
          score: checkedOption.value ? checkedOption.value + '_' + checkedOption.label : '',
          inputValue: item.inputValue || '',
          tag: tag,
        };
      });
    // 补答（非分数类）
    let index_MP = question_paper.length + 1;
    if (dealPropery.is_get_medic == 0) {
      index_MP++
    }
    if (dealPropery.is_hs_zhiliao == 0 && dealPropery.is_only_hs_zhiliao == 0) {
      index_MP++
    }
    let question_paper_mp = quesListMP
      .filter(item => item.needComment)
      .map((item, i) => {
        let tag = [];
        let check = item.options ? item.options.find(ite => ite.checked) || {} : {};
        if (check.checked) {
          tag = [
            check.value + '_' + (check.note || check.label),
          ];
        }
        return {
          no: item.no,
          question: item.ques,
          type: item.type,
          index: index_MP + i, // 题目序号，加上前面几题
          score: (check.note || check.label) ? ('1_' + (check.note || check.label || '')) : '', // 1为必填项
          inputValue: item.inputValue || '',
          tag: tag,
        }
      })
    _form.question_paper = [question_paper, question_paper_mp].flat();
    setForm(_form);
    return _form;
  }
  /**
   * 初始化答案（暂存中获取）
   * @param {*}
   */
  const initAnswer = data => {
    let commentForm = storage.get('commentForm');
    if (commentForm && commentForm.deal_id == deal_id) {
      let form = commentForm.form;
      let _quesList = quesList.map(item => {
        // let ques = form.question_paper.find(ite => ite.no == item.no && ite.score) || {};
        let ques = form.question_paper.find(ite => ite.no == item.no) || {};
        if (item.no == ques.no) {
          item.options && item.options.map(it => {
            let score = ques.score.split('_');
            if (it.value == score[0]) {
              it.checked = true;
              it.list.map(l => {
                if (ques.tag.some(t => t.split('_')[0] == l.value)) {
                  l.checked = true;
                  if (l.remark) {
                    l.note = ques.tag.find(t => t.split('_')[0] == l.value)?.split('_')[1];
                  }
                }
                return l;
              });
            }
            return it;
          });
          if (item.type === 'textarea') {
            item.inputValue = ques.inputValue;
          }
        }
        return item;
      });
      let _quesListMP = quesListMP.map(item => {
        let ques = form.question_paper.find(ite => ite.no == item.no) || {};
        if (item.no == ques.no) {
          item.options.map(it => {
            if (ques.tag.some(t => t.split('_')[0] === it.value)) {
              it.checked = true;
              if (it.remark) {
                it.note = ques.tag.find(t => t.split('_')[0] == it.value)?.split('_')[1];
              }
            }
            return it;
          })
        }
        return item;
      })

      // 衍生题目 （2_1）2-1中score为3的a4 和4的a2 需要衍生出填空题 2_2
      // let ques2_1 = _quesList.find(item => item.no === '2_1') || {};
      // if (ques2_1.no === '2_1' && ques2_1.needComment) {
      //   let a2_4 = ques2_1.options.some(item => item.checked && item.value === '4' && item.list.some(ite => ite.checked && ite.value === 'a2' ))
      //   let a4_3 = ques2_1.options.some(item => item.checked && item.value === '3' && item.list.some(ite => ite.checked && ite.value === 'a4' ))
      //   let index = _quesList.findIndex(item => item.no === '2_2')
      //   if (a2_4 || a4_3) {
      //     _quesList[index].needComment = true
      //   } else {
      //     _quesList[index].needComment = false
      //   }
      // } else {
      //   let index = _quesList.findIndex(item => item.no === '2_2')
      //   _quesList[index].needComment = false
      // }
      _quesList = initQues2_1(_quesList);

      setQuesList(_quesList);
      setQuesListMP(_quesListMP);
      setForm(form);
      setTmap(commentForm.tmap || {});
    }
  };

  /**
   * 初始化题目
   * @param {*} data
   * @param {*} deal
   */
  const initQues = (data, deal) => {
    let ques = quesList;
    let ques2 = quesListMP;
    if (data.is_get_medic == 0) {
      // ques[1].needComment = false;
      let index = ques.findIndex(item => item.no === '2_1');
      ques[index].needComment = false;
    }
    if (data.is_hs_zhiliao == 0 && data.is_only_hs_zhiliao == 0) {
      // ques[2].needComment = false;
      let index = ques.findIndex(item => item.no === '3_1');
      ques[index].needComment = false;
    }
    if (deal.gst_first == 2) { // 集团首诊才会有来源题目
      ques2[0].needComment = true;
    }

    setQuesList(ques);
    setQuesListMP(ques2)
    initAnswer();

    // 衍生题目
  };

  /**
   * 2_1的衍生题目
   * @param {*} quest 题目
   * @return quest
   */
  const initQues2_1 = (quest) => {
    if (!quest) return;
    let ques2_1 = quest.find(item => item.no === '2_1') || {};
    if (ques2_1.no === '2_1' && ques2_1.needComment) {
      let a2_4 = ques2_1.options.some(item => item.checked && item.value === '4' && item.list.some(ite => ite.checked && ite.value === 'a2' ))
      let a4_3 = ques2_1.options.some(item => item.checked && item.value === '3' && item.list.some(ite => ite.checked && ite.value === 'a4' ))
      let index = quest.findIndex(item => item.no === '2_2')
      if (a2_4 || a4_3) {
        quest[index].needComment = true
      } else {
        quest[index].needComment = false
      }
    } else {
      let index = quest.findIndex(item => item.no === '2_2')
      quest[index].needComment = false
    }
    return quest;
  }
  /**
   * 查询订单问题类型信息
   * @returns
   */
  const onQueryDealPropery = async () => {
    let params = {
      user_id,
      deal_id,
    };
    return new Promise(async (resolve, reject) => {
      try {
        const res = await queryDealPropery(params);
        console.log(res.code);
        if (res.code == 200) {
          setDealPropery(res.data);
          resolve(res.data);
        } else {
          Toast.fail(res.detail);
          reject(res.data);
        }
      } catch (error) {
        if (error.code == 69634) {
          Toast.fail('查询数据为空');
        } else {
          Toast.fail(error.detail);
        }
      }
    });
  };

  /**
   *
   * @returns 查询订单信息
   */
  const getDeal = async () => {
    return new Promise(async (resolve, reject) => {
      // const res = await queryDeal({
      //   deal_id,
      //   user_id,
      // });
      const res = await querySimpleDealDetail({
        deal_id,
        user_id,
      });
      if (res.code == 200) {
        // setDeal(res.data[0]);
        // resolve(res.data[0]);
        setDeal(res.data);
        resolve(res.data);
      } else {
        reject(res);
        Toast.fail(`获取订单信息失败`);
      }
    });
  };

  /**
   * 医生信息
   * @param {*} doctor_id
   */
  const getDoctorDetail = async doctor_id => {
    const res = await queryDoctorDetail({doctor_id});
    if (res.code == 200) {
      setDoctor(res.data);
    }
  };

  /**
   * 处理打分题目
   * @param {*} value
   */
  const onRate = value => {
    form.score = `${value}`;
    if (warnQues.includes('score')) {
      let _warnQues = warnQues.filter(item => item !== 'score');
      setWarnQues([..._warnQues]);
    }
    setForm({...form});
    saveAnswer();
  };

  /**
   * 处理医生标签
   * @param {*} val
   * @param {*} idx
   */
  const onSelectTag = (val, idx) => {
    // console.log(val, idx)
    const map = {...tmap};
    if (map[idx]) {
      map[idx] = false;
    } else {
      map[idx] = true;
    }
    setTmap({...map});
    saveAnswer(map);
  };

  /**
   * 医生评价框
   * @param {*} e
   */
  const onChangeCmt = e => {
    form.comment = e.target.value;
    setForm({...form});
    saveAnswer();
  };
  const onGetScore = score => {
    form.referral_score = `${score}`;
    if (warnQues.includes('referral_score')) {
      let _warnQues = warnQues.filter(item => item !== 'referral_score');
      setWarnQues([..._warnQues]);
    }
    setForm({...form});
    console.log(form, 'form');
    saveAnswer();
    // popoverTextFun()
  };

  /**
   * 获取医生标签
   */
  const queryCommentTag = async () => {
    const {data} = await fetchCommentTag({
      method: 5,
      page_no: 1,
      page_size: 999,
    });
    let _docTag = data && data.filter(item => item.tag_type === '1'); // 医生标签
    let _phTag = data && data.filter(item => item.tag_type === '3'); // 评价短语
    setTagList(_docTag);
    setPhraseList(_phTag);
  };

  // 选项选择（满意，一般，不满意）
  const handleCheck = (no, option) => {
    let _ques = quesList.map(item => {
      if (item.no === no) {
        item.options.map(ite => {
          if (ite.value === option.value) {
            ite.checked = true;
          } else {
            ite.checked = false;
          }
          return ite;
        });
      }
      return item;
    });

    _ques = initQues2_1(_ques)
    if (warnQues.includes(no)) {
      let _warnQues = warnQues.filter(item => item !== no);
      setWarnQues([..._warnQues]);
    }
    setQuesList(_ques);
    saveAnswer();
  };

  // 具体选项详情选择
  const onChangeChecked = (e, ques, option, t) => {
    let _ques = quesList.map(item => {
      if (item.no === ques.no) {
        let _option = option;
        let index = item.options.findIndex(ite => ite.value === option.value && ite.checked);
        console.log(_option);
        _option.list.map(ite => {
          if (ite.value === t.value) {
            ite.checked = e;
          }
          return {...ite};
        });
        item.options[index] = _option;
        console.log(item);
      }
      return item;
    });
    _ques = initQues2_1(_ques);
    setQuesList(_ques);
    saveAnswer();
  };

  /**
   * 题目类型2
   * @param {*} e
   * @param {*} ques
   */
  const onChangeCheckedMP2 = (e, ques) => {
    let _quesMP = quesListMP.map(item => {
      if (item.no === ques.no) {
        item.options.map(ite => {
          if (ite.value === e.value) {
            ite.checked = true;
          } else {
            ite.checked = false;
          }
          return ite;
        });
      }
      return item;
    })
    setQuesListMP([..._quesMP])
    saveAnswer();
  }
  const onFocus = (e, ques, option, t) => {
    let _ques = quesList.map(item => {
      if (item.no === ques.no) {
        let _option = option;
        let index = item.options.findIndex(ite => ite.value === option.value);
        _option.list.map(ite => {
          if (ite.value === t.value && ite.remark) {
            ite.checked = true;
          }
          return {...ite};
        });
        item[index] = _option;
      }
      return item;
    });
    setQuesList([..._ques]);
    saveAnswer();
  };

  // 其他内容
  const onChangeNote = (e, ques, option, t) => {
    let _ques = quesList.map(item => {
      if (item.no === ques.no) {
        let _option = option;
        let index = item.options.findIndex(ite => ite.value === option.value);
        _option.list.map(ite => {
          if (ite.value === t.value && ite.remark) {
            ite.note = e.target.value;
          }
          return {...ite};
        });
        item[index] = _option;
      }
      return item;
    });
    setQuesList(_ques);
    saveAnswer();
  };

  const onFocusQues2 = (e, ques) => {
  //   let _quesMP = quesListMP.map(item => {
  //     if (item.no === ques.no) {
  //       item.options.map(ite => {
  //         if (ite.value === e.target.value) {
  //           ite.checked = true;
  //         } else {
  //           ite.checked = false;
  //         }
  //         return ite;
  //       });
  //     }
  //     return item;
  //  })
  //  setQuesListMP([..._quesMP])
  }

  const onChangeQues2Note = (e, ques) => {
    console.log(e, ques, e.target.value)
    let _ques = quesListMP.map(item => {
      if (item.no === ques.no) {
        item.options.map(ite => {
          console.log(ite)
          if (ite.checked && ite.remark) {
            ite.note = e.target.value;
          }
          return {...ite};
        });
      }
      return item;
    });
    setQuesListMP([..._ques])
    saveAnswer();
  }

  const onInputQuest = (e, ques) => {
    let _ques = quesList.map(item => {
      if (item.no === ques.no) {
        item.inputValue = e.target.value;
      }
      return item;
    });
    setQuesList(_ques);
    saveAnswer();
  };
  /**
   *
   * @param {Object} formData
   * @returns
   */
  // 校验Form
  const validateForm = (formData) => {
    let _form = formData || form;
    let {question_paper} = _form;
    let required_ques = quesList.filter(item => item.required);
    let required_quesMP = quesListMP.filter(item => item.required);
    let required_ques_all = [...required_ques, ...required_quesMP];
    let _notAns = question_paper.filter(item => ((!item.score && item.type === 'radio') || (!item.inputValue.trim() && item.type === 'textarea')) && required_ques_all.some(ite => item.no === ite.no));
    let notAns = Array.from(
      _notAns,
      x => x.no
    );

    let indexAns = Array.from(
      _notAns,
      x => x.index
    );

    let need = quesList.filter(item => item.needComment);
    if (!_form.score && dealPropery.is_only_hs_zhiliao != 1) {
      notAns.push('score');
      indexAns.push(need.length + 1);
      // return;
    }
    if (!_form.referral_score && dealPropery.is_only_hs_zhiliao != 1) {
      notAns.push('referral_score');
      indexAns.push(need.length + 2);
      // return;
    }
    if (notAns.length > 0) {
      Toast.info(`${indexAns.join('、')}还未评价`);
      setWarnQues(notAns);
      aLink(notAns[0]);
      return false;
    }
    return true;
  };

  const aLink = id => {
    const a = document.createElement('a');
    a.href = '#' + id;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const onSubmit = () => {
    // // 医生标签
    // let tags = [];
    // const arr = Object.entries(tmap).filter(item => item[1]);
    // arr.forEach(item => {
    //   const {score_type, tag, tag_id, tag_type} = tagList[item[0]];
    //   tags.push({
    //     score_type,
    //     tag_type,
    //     tag_id,
    //     tag_name: tag,
    //   });
    // });
    // form.tag = tags;

    // // 问答（分数类）
    // let question_paper = quesList
    //   .filter(item => item.needComment)
    //   .map((item, i) => {
    //     let tag = [];
    //     let checkedOption = item.options.find(ite => ite.checked) || {};
    //     if (checkedOption.value) {
    //       let check = checkedOption.list.filter(ite => ite.checked && !ite.remark);
    //       let remark = checkedOption.list.filter(ite => ite.checked && ite.remark && ite.note);
    //       tag = [
    //         ...Array.from(check, x => x.value + '_' + x.label),
    //         ...Array.from(remark, x => x.value + '_' + x.note),
    //       ];
    //     }
    //     return {
    //       no: item.no,
    //       question: item.ques,
    //       required: item.required,
    //       index: i + 1,
    //       score: checkedOption.value ? checkedOption.value + '_' + checkedOption.label : '',
    //       tag: tag,
    //     };
    //   });

    // // 补答（非分数类）
    // let index_MP = question_paper.length + 1;
    // if (dealPropery.is_get_medic == 0) {
    //   index_MP++
    // }
    // if (dealPropery.is_hs_zhiliao == 0 && dealPropery.is_only_hs_zhiliao == 0) {
    //   index_MP++
    // }
    // let question_paper_mp = quesListMP
    //   .filter(item => item.needComment)
    //   .map((item, i) => {
    //     let tag = [];
    //     let check = item.options.find(ite => ite.checked) || {};
    //     if (check.checked) {
    //       tag = [
    //         check.value + '_' + (check.note || check.label),
    //       ];
    //     }
    //     console.log(item);
    //     return {
    //       no: item.no,
    //       question: item.ques,
    //       index: index_MP + i, // 题目序号，加上前面几题
    //       // score: '1_' + (check.note || check.label), // 1为必填项
    //       score: '',
    //       tag: tag,
    //     }
    //   })
    // form.question_paper = [...question_paper, ...question_paper_mp];
    let _form = getAnsResult();
    // console.log(_form)
    // setForm({..._form});
    if (!validateForm(_form)) {
      return;
    }
    httpRequest(() => {
      storage.remove('commentForm');
      Modal.alert(comment_id ? '修改成功' : '提交成功', '', [
        {
          text: '确定',
          // style: {
          //   color: '#C3924D'
          // },
          onPress: () => {
            getEnv(res => {
              if (res == 'miniprogram') {
                let wx = window.wx || {};
                if (isMP) {
                  wx.miniProgram.switchTab({
                    url: `/pages/user/index`, //跳转到小程序个人页
                  });
                } else {
                  wx.miniProgram.switchTab({
                    url: `/pages/userCenter/index`, //跳转到omo小程序个人页
                  });
                }
              } else if (res == 'iOSApp') {
              } else if (res == 'androidApp') {
              } else if (res == 'h5') {
                locationTo(location.origin + '/usercenter');
              } else {
                locationTo(location.origin + '/usercenter');
              }
            });
          },
        },
      ]);
    });
  };

  const httpRequest = async cb => {
    Toast.loading('加载中...', 0);
    const {
      deal_id,
      doctor_id,
      achi_doctor_id,
      achi_doctor_name,
      city_id = '0',
      mis_doctor_id,
      doctor_name,
      clinic_name,
      clinic_id,
      patient_id,
      patient_name,
      patient_sex,
      patient_age,
      patient_birth,
      patient_phone,
      ai_workroom,
      ai_workroom_id,
      ai_workroom_name,
    } = deal;
    const {doctor_img} = doctor;
    let params = {
      ...form,
      deal_id: String(deal_id),
      doctor_head: doctor_img,
      doctor_id: String(doctor_id),
      mis_doctor_id: String(mis_doctor_id),
      doctor_name: doctor_name,
      user_id: String(user_id),
      city_id: String(city_id),
      clinic_name,
      clinic_id: String(clinic_id),
      visit_user_id: String(patient_id),
      visit_user_name: patient_name,
      visit_user_sex: String(patient_sex),
      visit_user_age: String(dayjs().diff(dayjs(patient_birth), 'year')),
      patient_phone: String(patient_phone),
      // question_paper: question_paper,
      type: '1',
    };
    if (ai_workroom == 1) {
      params.ai_workroom = ai_workroom;
      params.ai_workroom_id = ai_workroom_id;
      params.doctor_id = ai_workroom_id;
      params.doctor_name = ai_workroom_name || 'xx工作室';
    }
    if (comment_id) {
      params.comment_id = comment_id;
    }
    Toast.loading('提交中...');
    const res = comment_id ? await editComment(params) : await saveComment(params);
    Toast.hide();
    const {status, message, coupon_list} = res;
    Toast.hide();
    if (status === '0') {
      cb && cb();
    } else {
      Toast.info(message, 2);
    }
  };
  const onProgress = () => {
    let _visiblePopover = visiblePopover;
    setVisiblePopover(!_visiblePopover);
  };
  const getQuesIndex = () => {
    let length = quesList.filter(item => item.needComment).length; // 当前问卷长度
    if (dealPropery.is_only_hs_zhiliao == 0) length = length + 2; // 如果不是仅治疗项目，则多加两个问题
    return length + 1;
  }
  return (
    <section className="comment-index-page">
      {showHeader && <BackHeader title={'固生堂服务评价'} />}
      {!loading && (
        <GstProgessBar
          percent={percent}
          content={popoverText}
          visiblePopover={visiblePopover}
          onProgress={onProgress}
        ></GstProgessBar>
      )}
      {loading ? (
        <div className="skeleton">
          <Skeleton.Paragraph lineCount={5} animated></Skeleton.Paragraph>
          <Skeleton.Paragraph lineCount={5} animated></Skeleton.Paragraph>
          <Skeleton.Paragraph lineCount={5} animated></Skeleton.Paragraph>
          <Skeleton.Paragraph lineCount={5} animated></Skeleton.Paragraph>
          <Skeleton.Paragraph lineCount={5} animated></Skeleton.Paragraph>
        </div>
      ) : (
        <div className="main">
          <div>
            {quesList
              .filter(item => item.needComment)
              .map((item, index) => {
                return (
                  <div
                    className={`ques check ${warnQues.includes(item.no) ? 'warningColor' : ''}`}
                    key={index}
                    id={item.no}
                  >
                    <Title title={`${index + 1}.${item.ques}`} required />
                    {
                      item.type === 'radio' ? (
                        <div>
                          <div className="options">
                            {item.options.map((option, i) => {
                              return (
                                <div
                                  key={i}
                                  className={`option ${option.checked ? 'checked' : ''}`}
                                  onClick={() => handleCheck(item.no, option)}
                                >
                                  <img
                                    src={option.checked ? icons[option.value].icon : icons[option.value].iconGray}
                                    alt=""
                                  />
                                  <p>{option.label}</p>
                                </div>
                              );
                            })}
                          </div>
                          <div className="option-list">
                            {item.options.find(ite => ite.checked) &&
                              item.options
                                .find(ite => ite.checked)
                                .list.map((t, i) => {
                                  return (
                                    <div
                                      className={`option-list-item ${t.checked ? 'checked' : ''}`}
                                      key={i}
                                      onClick={e =>
                                        onChangeChecked(
                                          !t.checked,
                                          item,
                                          item.options.find(ite => ite.checked),
                                          t
                                        )
                                      }
                                    >
                                      {t.label}
                                    </div>
                                  );
                                })}
                          </div>
                          <TextAreaChild item={item} options={item.options} onChangeNote={onChangeNote} onFocus={onFocus} />
                        </div>
                      ) : null
                    }
                    {
                      item.type === 'textarea' ? (
                        <textarea
                          onInput={(e) => onInputQuest(e, item)}
                          value={item.inputValue}
                          className="txt"
                          placeholder={item.placeholder}
                        />
                      ) : null
                    }
                  </div>
                );
              })}
            {dealPropery.is_only_hs_zhiliao == 0 ? (
              <div className='ques'>
                <div className={`ques check ${warnQues.includes('score') ? 'warningColor' : ''}`}>
                  <Title
                    title={`${quesList.filter(item => item.needComment).length + 1}.就诊结束了，为<span class="mark">${
                      deal.doctor_name
                    }</span>医生打个分吧`}
                    required
                  />
                  <div className="score">
                    <label className="rate-label">综合评分</label>
                    <div className="rate">
                      <Rate value={Number(form.score || 0)} onChange={onRate}></Rate>
                    </div>
                  </div>
                  {form.score >= 4 ? (
                    <div>
                      <div className="tag-list">
                        {tagList.map((item, idx) => {
                          return (
                            <div
                              className={`tag ${tmap[idx] ? 'active' : ''}`}
                              key={idx}
                              onClick={() => onSelectTag(item, idx)}
                            >
                              {item.tag}
                            </div>
                          );
                        })}
                      </div>
                      {/* <textarea
                        onInput={onChangeCmt}
                        value={form.comment}
                        className="txt"
                        placeholder={'感谢你的评价，还有什么话想对医生说？'}
                      /> */}
                    </div>
                  ) : null}
                  <div>
                    <textarea
                      onInput={onChangeCmt}
                      value={form.comment}
                      className="txt"
                      placeholder={'感谢你的评价，还有什么话想对医生说？'}
                    />
                  </div>
                </div>
                <div className={`ques check ${warnQues.includes('referral_score') ? 'warningColor' : ''}`}>
                  <Title
                    title={`${quesList.filter(item => item.needComment).length + 2}.您是否愿意推荐<span class="mark">${
                      deal.doctor_name
                    }</span>医生给其他人？`}
                    required
                  />
                  <div className="score">
                    <label className="rate-label">综合评分</label>
                    <div className="rate">
                      <Rate
                        value={Number(form.referral_score || 0)}
                        onChange={onGetScore}
                        rateText={['非常不愿意', '不愿意', '一般', '愿意', '非常愿意']}
                      ></Rate>
                    </div>
                  </div>
                </div>
              </div>

            ) : null}
            <div className=''>
              {quesListMP
              .filter(item => item.needComment)
              .map((item, index) => {
                return (
                  <div
                    className={`ques check ${warnQues.includes(item.no) ? 'warningColor' : ''}`}
                    key={index}
                    id={item.no}
                  >
                    <Title title={`${getQuesIndex()}.${item.ques}`} />
                    <div className="option-list">
                      {item.options.map((t, i) => {
                        return (
                          <div
                            className={`option-list-item ${t.checked ? 'checked' : ''}`}
                            key={i}
                            onClick={e =>
                              onChangeCheckedMP2(
                                t,
                                item,
                              )
                            }
                          >
                            {t.label}
                          </div>
                        );
                      })}
                    </div>
                    <div>
                      {
                        item.options.find(ite => ite.remark)?.checked ? (
                          <textarea
                            className="txt"
                            value={item.options.find(ite => ite.checked).note}
                            onFocus={e =>
                              onFocusQues2(
                                e,
                                item,
                              )
                            }
                            onChange={e =>
                              onChangeQues2Note(
                                e,
                                item,
                              )
                            }
                            placeholder="其他渠道"
                          >

                          </textarea>
                        ) : null
                      }
                    </div>

                    {/* <TextAreaChild item={item} options={item.options} onChangeNote={onChangeNote} onFocus={onFocus} /> */}
                  </div>
                );
              })}
            </div>
          </div>
          <button className="comment-btn" onClick={onSubmit}>
            提交
          </button>
        </div>
      )}
    </section>
  );
};

export default CommentIndex;

export const TextAreaChild = props => {
  let {item, options, onChangeNote, onFocus} = props;
  let show =
    options.find(ite => ite.checked) &&
    options.find(ite => ite.checked).list &&
    options.find(ite => ite.checked).list.find(ite => ite.remark).checked;
  let _item = show ? options.find(ite => ite.checked).list.find(ite => ite.remark) : {};
  return show ? (
    <textarea
      className="txt"
      value={_item.note}
      onFocus={e =>
        onFocus(
          e,
          item,
          options.find(ite => ite.checked),
          _item
        )
      }
      onChange={e =>
        onChangeNote(
          e,
          item,
          item.options.find(ite => ite.checked),
          _item
        )
      }
      placeholder="请输入我们有哪些服务不到位的地方"
    ></textarea>
  ) : null;
};
